// @ts-ignore
/* eslint-disable */
import { request } from '@/services/transit.request';

/** Get all transit notifications GET /api/v1/crm/transit-notifications */
export async function transitNotificationsListWithPaging(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.transitNotificationsListWithPagingParams,
  options?: { [key: string]: any },
) {
  return request<API.PagingResponseDto>('/api/v1/crm/transit-notifications', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** Create a new transit notification POST /api/v1/crm/transit-notifications */
export async function transitNotificationsCreate(
  body: API.CreateTransitNotificationDto,
  options?: { [key: string]: any },
) {
  return request<API.TransitNotification>('/api/v1/crm/transit-notifications', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** Get a transit notification by ID GET /api/v1/crm/transit-notifications/${param0} */
export async function transitNotificationsGetById(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.transitNotificationsGetByIdParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.TransitNotification>(
    `/api/v1/crm/transit-notifications/${param0}`,
    {
      method: 'GET',
      params: { ...queryParams },
      ...(options || {}),
    },
  );
}

/** Update a transit notification by ID PUT /api/v1/crm/transit-notifications/${param0} */
export async function transitNotificationsUpdateById(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.transitNotificationsUpdateByIdParams,
  body: API.UpdateTransitNotificationDto,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.UpdateManyResultDto>(
    `/api/v1/crm/transit-notifications/${param0}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    },
  );
}

/** Delete a transit notification by ID (soft delete) DELETE /api/v1/crm/transit-notifications/${param0} */
export async function transitNotificationsDeleteById(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.transitNotificationsDeleteByIdParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/api/v1/crm/transit-notifications/${param0}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** Mark all NEW transit notifications as READ PUT /api/v1/crm/transit-notifications/mark-all-read */
export async function transitNotificationsMarkAllRead(options?: {
  [key: string]: any;
}) {
  return request<API.UpdateManyResultDto>(
    '/api/v1/crm/transit-notifications/mark-all-read',
    {
      method: 'PUT',
      ...(options || {}),
    },
  );
}
